import Storage from "./../utils/storage";
import Store from "./../store/index";
import { replace } from "@/utils/location";
import { loginUri } from "@/config/application";
import { processDynamicRouter } from "@/router/generator-routers";
import { VUE_APP_PTYPE } from "@/config/env";
import LoadingGifSY from "@/assets/loading-sy.gif";
import LoadingGifTX from "@/assets/loading-tx.gif";
import { currentHref } from "@/utils/location";
console.log(VUE_APP_PTYPE);
// import { BasicLayout } from '@/layouts'
let isLoginError = false;
const handleError = (errorMsg) => {
  setTimeout(() => {
    console.log(errorMsg);
    Storage("token").del();
    if (currentHref.indexOf("/base_info") > -1) {
      localStorage.setItem("redirect_base", currentHref);
    }
    replace(loginUri);
    isLoginError = true;
  }, 0);
};
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
  const match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : "";
}
async function processLoadingState(isClose) {
  const globalLoading = document.getElementById("globalLoading");
  const loadingGifContainer = document.getElementById("loadingGif");
  if (VUE_APP_PTYPE === "sy") {
    loadingGifContainer.src = LoadingGifSY;
  } else {
    loadingGifContainer.src = LoadingGifTX;
  }
  if (isClose) {
    setTimeout(() => {
      globalLoading.style.opacity = "0";
      setTimeout(() => {
        globalLoading.remove();
      }, 500);
    }, 1000);
  }
}

async function processMenu(to) {
  if (to.path === "/enterprise-list/list") {
    Store.state.application.showMenu = false;
  } else {
    Store.state.application.showMenu = true;
  }
}

const processRoutes = (function() {
  // bug: 避免后台将菜单返回空数组的时候重复调用菜单接口
  let isGetAsyncRoutes = false;
  return async function(to, router, next) {
    if (
      !Store.getters.originRoutes.length &&
      !isGetAsyncRoutes &&
      !isLoginError
    ) {
      await Store.dispatch("getAsyncOriginRoutes");
      const routeMap = processDynamicRouter(Store.getters.originRoutes);
      router.addRoutes(routeMap);
      Store.commit("mergeRoutes", routeMap);
      isGetAsyncRoutes = true;
      setTimeout(() => {
        next({ ...to, replace: true });
      }, 0);
    }
  };
})();

// 设置标题
function processTitle({ meta }) {
  if (meta.title) Store.dispatch("setAppTitle", meta.title);
}

// 用户登录授权相关操作
async function processUserOperation() {
  const { token } = Storage("token");
  Store.state.user.token = token;
  const userInfo = JSON.stringify(Store.getters.userInfo);
  const applicationInfo = JSON.stringify(Store.state.application.info);
  Store.state.user.token = token;
  const isGetToken = token === null;
  if (isGetToken) {
    try {
      await Store.dispatch("getLoginToken");
    } catch (error) {
      handleError(error);
    }
  }
  // 校验当前token后获取用户信息
  const isGetUserInfo = userInfo === "{}" && !isLoginError;
  if (isGetUserInfo) {
    try {
      await Store.dispatch("checkCurrentUser");
      await Store.dispatch("getUserInfo");
    } catch (error) {
      handleError(error);
    }
  }
  const isGetApplicationInfo = applicationInfo === "{}" && !isLoginError;
  if (isGetApplicationInfo) {
    await Store.dispatch("setApplicationInfo");
  }
  processLoadingState(true);
}
// 切换登录模式
async function processLoginMode({ query }) {
  processLoadingState();
  const loginDataModel = (function() {
    return {
      key: String,
      sysID: String,
    };
  })();
  // 为true则切换登录模式
  let isSwitchLoginMode = false;
  for (const k in query) {
    if (loginDataModel.hasOwnProperty(k)) {
      if (loginDataModel[k] && getType(loginDataModel[k]) === "String") {
        isSwitchLoginMode = true;
      } else {
        isSwitchLoginMode = false;
        break;
      }
    }
  }
  if (isSwitchLoginMode) {
    try {
      await Store.dispatch("switchLoginModel", query);
    } catch (error) {
      handleError(error);
    }
  }
}

export default (router) => {
  router.beforeEach(async (to, from, next) => {
    await processLoginMode(to);
    await processUserOperation();
    await processRoutes(to, router, next);
    await processMenu(to, router, next);
    processTitle(to);
    debugger;
    if (JSON.stringify(Store.getters.userInfo) !== "{}") {
      const redirect_base = localStorage.getItem("redirect_base");
      if (redirect_base) {
        if (currentHref.indexOf("base_info") > -1) {
          localStorage.removeItem("redirect_base");
          next();
        } else {
          replace(redirect_base);
        }
      } else {
        next();
      }
    } else {
      replace(loginUri);
    }
  });
};
